import { render, staticRenderFns } from "./ComplexMedicalList.vue?vue&type=template&id=438954cf&scoped=true"
import script from "./ComplexMedicalList.vue?vue&type=script&lang=js"
export * from "./ComplexMedicalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438954cf",
  null
  
)

export default component.exports